import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors, padding } from '@grnhse/seedling/lib/azalea/constants';

export default class FileInfoContainer extends React.Component {
  static propTypes = {
    selectedFilesText: PropTypes.string.isRequired,
    removeFilesText: PropTypes.string.isRequired,
    onRemoveLinkClick: PropTypes.func.isRequired,
  };

  render() {
    const { selectedFilesText, removeFilesText, onRemoveLinkClick } =
      this.props;

    return (
      <Container className="file-info-container">
        <span className="selected-files-label">{selectedFilesText}</span>
        &nbsp;|&nbsp;
        <RemoveFilesLink onClick={onRemoveLinkClick}>
          {removeFilesText}
        </RemoveFilesLink>
      </Container>
    );
  }
}

const Container = styled.div`
  margin: ${padding.tiny};
  margin-bottom: ${padding.small};
`;

const RemoveFilesLink = styled.a`
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  color: ${colors.darkRed};
`;
